// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5i-6";
export var headerCell = "_5i-2";
export var rowWrapper = "_5i-4";
export var stickyAggregationCell = "_5i-a";
export var stickyAggregationRow = "_5i-7";
export var stickyColumnCell = "_5i-9";
export var stickyColumnHeaderCell = "_5i-8";
export var table = "_5i-1";
export var virtualRowWrapper = "_5i-5";
export var virtualTableContainer = "_5i-0";
export var white = "_5i-3";